<template>
  <div>
    <TopBar pagetitle="验证潜水员身份" :back-url="backurl" />

    <div v-if="!loadingPage">
      <div class="rect">
        <div class="selectRect">
          <div class="input select">
            <i class="iconfont icondown_jiantou" />
            <input v-model="typeShow" readonly placeholder="选择机构" @click="onShowTypeSelect">
          </div>
        </div>
        <div v-for="item in imgRes" :key="item.title" class="imgRect">
          <div v-if="item.img" class="img" @click="onShowBigImg(item.img)"><i class="iconfont iconabout" />示例</div>

          <div class="center"><p><i class="iconfont iconadd" /></p>{{ item.title }}</div>

          <div class="imgprivel">
            <van-image
              width="100%"
              height="100%"
              fit="contain"
              :src="item.upimg"
            />

          </div>
          <div class="imgprivel">
            <van-uploader :after-read="afterRead" :name="item.key">
              <div class="uploadButton" />
            </van-uploader>
          </div>
        </div>

        <div v-if="!data.isBindPhone" class="phoneRect">
          <div class="title">手机验证</div>
          <div class="input inputRight">
            <i class="iconfont iconTel" />
            <input v-model="dataForm.phone" placeholder="手机号码">
            <div class="rightButton" @click="sendCode">{{ sendCodeTitle }}</div>
          </div>
          <div class="input" style="margin-top: 0.5em;">
            <i class="iconfont iconshezhi" />
            <input v-model="dataForm.phoneCode" placeholder="输入验证码">
          </div>
        </div>
        <div class="emptyRect" />
      </div>
      <div class="downButton">
        <van-button type="info" :loading="loadingButton" square @click="onActivity">确认潜水员信息，领取潜水员“魔法棒”</van-button>
      </div>
    </div>
    <van-popup v-model="showTypeSelect" position="bottom">
      <van-picker
        show-toolbar
        title="选择潜水机构"
        :columns="typeSelectList"
        @cancel="onCancelType"
        @confirm="onConfirmType"
      />
    </van-popup>

    <van-dialog
      v-model="showfollowWx"
      title="请关注SSI国际水肺潜水学校公众号"
      show-cancel-button
      @confirm="onFllowConfirm"
      @cancel="onFllowCancel"
    >
      <img class="qrCode" src="/img/qrwx.jpg ">
    </van-dialog>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { getUrlKey, MyNotify, compressorImage } from '@/utils/base'
import { Button, Popup, Picker, ImagePreview, Uploader, Image, Dialog, Toast } from 'vant'
import Cookies from 'js-cookie'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [ImagePreview.name]: ImagePreview,
    [Uploader.name]: Uploader,
    [Image.name]: Image,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    TopBar
  },
  data() {
    return {
      backurl: '/activity/group',
      loadingPage: true,
      loadingButton: false,
      showTypeSelect: false,
      showfollowWx: false,
      dataForm: {
        phone: '',
        phoneCode: '',
        trueBind: true,
        phoneArea: '86',
        birthday: undefined
      },
      dataFormActivity: {
        activityType: undefined,
        activityImgRes: ''
      },
      typeShow: undefined,
      data: {
        isBindPhone: false,
        isBindSSI: false
      },
      sendCodeTitle: '获取验证码',
      buttonEnabel: false,
      totalTime: -1,
      imgRes: [],
      image0: undefined,
      image0Name: undefined,
      image1: undefined,
      image1Name: undefined,
      typeSelectList: [
        { text: 'SSI国际水肺潜水学校', value: 'SSI' },
        // { text: 'PADI电子卡', value: 'EPADI', imgRes: [
        //   { key: '0', upimg: '/img/empty.png', title: '请上传PADI电子卡片能清楚看到完整二维码截图', img: '/img/activity_padie.jpg' }
        // ] },
        // { text: 'PADI塑料卡', value: 'PADI', imgRes: [
        //   { key: '0', upimg: '/img/empty.png', title: '请上传PADI塑料卡片信息页照片', img: '/img/activity_padi.jpg' }
        // ] },
        { text: '其他组织', value: 'OTHER', imgRes: [
          { key: '0', upimg: '/img/empty.png', title: '请上传可以证明资质证书的照片' },
          { key: '1', upimg: '/img/empty.png', title: '其他证明材料' }
        ] }
      ]
    }
  },
  mounted() {
    console.log('进入')
    document.getElementsByTagName('body')[0].className = 'activeBacl'
    var type = Cookies.get('activityType_')
    if (type) {
      this.dataFormActivity.activityType = type
      this.typeShow = Cookies.get('activityTypeName_')
    } else {
      this.dataFormActivity.activityType = undefined
    }
  },
  destroyed: function() {
    console.log('离开')
    document.body.removeAttribute('class', 'activeBacl')
  },
  created() {
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.init()
  },
  methods: {
    init() {
      Toast.loading({
        mask: false,
        message: '加载中...'
      })
      request({
        url: '/Activity/getUserSimpleInfo',
        method: 'post'
      }).then(Response => {
        if (Response.success) {
          this.data = Response.data
          if (!this.data.followWx) {
            this.$store.dispatch('user/resetToken', '')
            this.showfollowWx = true
            return
          }
          if (this.data.inTeam) {
            Cookies.remove('activityCardKey_')
            this.$router.replace('/activity/groupTeams')
            return
          }
          Toast.clear(true)
          this.loadingPage = false
          switch (this.data.type) {
            case 'WAIT':
              Dialog.confirm({
                title: '修改资料',
                message: '您的资料正在审核中，是否要修改资料？'
              }).catch(() => {
                this.$router.replace('/activity/groupTeamCreate?backurl=/activity/groupReg')
              })
              break
            case 'PASS':
              this.$router.replace('/activity/groupTeamCreate?backurl=/activity/group')
              return
            case 'CANCEl':
              Dialog.alert({
                title: '潜水员身份审核失败',
                message: '非常抱歉，您的潜水员资质审核失败，原因:' + this.data.verifyBody + ';是否要重新提交材料?'
              })
              break
          }
        }
      })
    },
    onFllowConfirm() {
      this.init()
    },
    onFllowCancel() {
      this.$router.replace('/activity/group')
    },
    onActivity() {
      if (this.dataFormActivity.activityType === 'SSI') {
        if (this.data.isBindPhone === true) {
          if (this.data.isBindSSI !== true) {
            Dialog.confirm({
              title: '尚未绑定SSI账号',
              message: '您尚未绑定SSI账号，是否现在绑定?'
            }).then(() => {
              this.$router.replace('/users/bindSSI?url=/activity/groupReg')
            })
            return
          }
        }
      }
      if (this.data.isBindPhone !== true) {
        if (this.dataForm.phone.trim().length !== 11) {
          MyNotify('info', '请输入11位手机号码')
          return
        }
        // var reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/
        var reg = /^1\d{10}$/
        if (!reg.test(this.dataForm.phone.trim())) {
          MyNotify('info', '请输入11位手机号码')
          return
        }
        if (this.dataForm.phoneCode.trim().length < 4) {
          MyNotify('info', '请输入验证码')
          return
        }
      }
      if (!this.dataFormActivity.activityType) {
        MyNotify('info', '请选择机构')
        return
      }
      if (this.dataFormActivity.activityType !== 'SSI') {
        if (!this.image0 && !this.image1) {
          MyNotify('info', '请上传资质照片')
          return
        }
      }
      this.loadingButton = true
      var my = this
      if (this.data.isBindPhone !== true) {
        this.regUser(this, () => {
          my.uploadRes(my, () => {
            my.activityCard(my, (data) => {
              if (data) {
                this.$router.replace('/activity/groupTeamCreate?backurl=/activity/group')
              } else {
                this.$router.replace('/activity/groupTeamCreate')
              }
            })
          })
        })
      } else {
        my.uploadRes(my, () => {
          my.activityCard(my, (data) => {
            if (data) {
              this.$router.replace('/activity/groupTeamCreate?backurl=/activity/group')
            } else {
              this.$router.replace('/activity/groupTeamCreate')
            }
          })
        })
      }
    },
    compressorFile(file, callback) {
      var u = navigator.userAgent
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      // eslint-disable-next-line no-undef
      new ImageCompressor(file, {
        checkOrientation: isIOS,
        quality: 0.6,
        maxHeight: 1024,
        maxWidth: 1024,
        success(result) {
          console.log('压缩图片成功', result)
          if (callback) {
            callback(result, result.name)
          }
        },
        error(e) {
          console.log('压缩图片失败', e)
          if (callback) {
            callback(file)
          }
        }
      })
    },
    uploadRes(my, callback) {
      if (!my.data.isBindSSI && my.dataFormActivity.activityType === 'SSI') {
        Dialog.confirm({
          title: '尚未绑定SSI账号',
          message: '您尚未绑定SSI账号，是否现在绑定?'
        }).then(() => {
          this.$router.replace('/users/bindSSI?url=/activity/groupReg')
        })
        my.loadingButton = false
        return
      }

      const formData = new FormData()
      var noFile = true
      if (my.image0) {
        if (my.image0Name) {
          formData.append('file', my.image0, my.image0Name)
        } else {
          formData.append('file', my.image0)
        }
        noFile = false
      }
      if (my.image1) {
        if (my.image0Name) {
          formData.append('file', my.image1, my.image1Name)
        } else {
          formData.append('file', my.image1)
        }
        noFile = false
      }
      if (noFile) {
        if (callback) {
          callback()
        }
        my.dataFormActivity.activityImgRes = ''
        return
      }
      request({
        url: '/Data/uploadFile?config=activityreg',
        method: 'post',
        data: formData
      }).then(response => {
        if (!response.success) {
          my.loadingButton = false
          return
        }
        var list = []
        response.data.map((value, index, array) => {
          list.push(value.save)
        })
        my.dataFormActivity.activityImgRes = list.toString()
        if (callback) {
          callback()
        }
      })
    },
    regUser(my, callback) {
      request({
        url: '/user/regPhone',
        method: 'post',
        data: my.dataForm
      }).then(Response => {
        if (!Response.success) {
          my.loadingButton = false
          return
        }
        this.$store.dispatch('user/resetToken', Response.data)
        my.data.isBindPhone = true
        if (callback) {
          callback()
        }
      })
    },
    activityCard(my, callback) {
      request({
        url: '/Activity/activityCard',
        method: 'post',
        data: my.dataFormActivity
      }).then(Response => {
        if (!Response.success) {
          my.loadingButton = false
          return
        }
        my.loadingButton = true
        if (callback) {
          callback(Response.data)
        }
      })
    },
    onShowTypeSelect() {
      this.showTypeSelect = true
    },
    onCancelType() {
      this.showTypeSelect = false
      this.dataFormActivity.activityType = undefined
      Cookies.remove('activityType_')
      Cookies.remove('activityTypeName_')
      this.typeShow = undefined
      this.imgRes = []
    },
    onConfirmType(value) {
      this.showTypeSelect = false
      Cookies.set('activityType_', value.value)
      Cookies.set('activityTypeName_', value.text)
      this.dataFormActivity.activityType = value.value
      this.typeShow = value.text
      this.imgRes = value.imgRes
      if (this.imgRes) {
        this.imgRes.forEach(item => {
          item.upimg = '/img/empty.png'
        })
        this.image0 = undefined
        this.image1 = undefined
      }
    },
    onShowBigImg(img) {
      ImagePreview([img])
    },
    afterRead(file, detail) {
      console.log(file)
      console.log(detail)
      if (detail.name === '0') {
        this.imgRes[0].upimg = file.content
        compressorImage(file.file, 1024, 1024, 0.6, (data, fileName) => {
          this.image0 = data
          this.image0Name = fileName
        })
      } else if (detail.name === '1') {
        this.imgRes[1].upimg = file.content
        compressorImage(file.file, 1024, 1024, 0.6, (data, fileName) => {
          this.image1 = data
          this.image1Name = fileName
        })
      }
    },
    sendCode() {
      if (this.totalTime >= 0) {
        return
      }
      if (this.dataForm.phone.trim().length !== 11) {
        MyNotify('info', '请输入11位手机号码')
        return
      }
      var reg = /^1\d{10}$/
      if (!reg.test(this.dataForm.phone.trim())) {
        MyNotify('info', '请输入11位手机号码')
        return
      }
      this.buttonEnabel = false
      request({
        url: '/user/SendRegSms',
        method: 'post',
        data: {
          phoneArea: '86',
          phone: this.dataForm.phone,
          hashCode: '123',
          type: 'ACTIVITY'
        }
      }).then(Response => {
        if (Response.success) {
          this.totalTime = Response.data
          this.sendCodeTitle = this.totalTime + 's后重发' // 这里解决60秒不见了的问题
          const clock = window.setInterval(() => {
            this.totalTime--
            this.sendCodeTitle = this.totalTime + 's后重发'
            if (this.totalTime < 0) { // 当倒计时小于0时清除定时器
              window.clearInterval(clock)
              this.sendCodeTitle = '获取验证码'
              this.buttonEnabel = true
            }
          }, 1000)
          MyNotify('success', '验证码发送成功!')
        } else {
          this.buttonEnabel = true
        }
      })
    }
  }
}
</script>
<style scoped>
.back{
  width: 100%;
  margin: 0;
  padding: 0;
  vertical-align:top;
}

.rect{
    padding: 1em 2em;
}
.inputRight{
     padding: 0 6em 0 4em !important;
}
.input .rightButton{
    position:absolute;
    padding-left: 1em;
    top:0.5em;
    right: 1em;
    border-left: 1px solid #fff;
    color: #fff;
    bottom: 0.5em;
     line-height: 2.125em;
     font-size: 0.8em;
}
.input{
    position: relative;
    background-color: transparent;
    border: 1px solid #ccc;
    padding: 0 1em 0 4em;
}
.input i{
    position:absolute;
    left: 0;
    top:0;
    height: 2.5em;
    line-height: 2.5em;
    color: #Fff;
    text-align: center;
    width: 4em;
}
.input input{
     background-color: transparent;
         height: 2.5em;
    line-height: 2.5em;
    color: #Fff;
    width: 100%;
    border: none;
}
.select input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
  color: #fff;
}

.select input:-moz-placeholder, textarea:-moz-placeholder {
  color: #fff;
}

.select input::-moz-placeholder, textarea::-moz-placeholder {
  color: #fff;
}

.select input:-ms-input-placeholder, textarea:-ms-input-placeholder {
  color: #fff;
}

.imgRect{
  position: relative;
    margin-top: 1em;
    background-color: #F0F0F0;
    height: 12em;
    text-align: center;
    position: relative;
}
.imgRect  .img{
    position: absolute;
    top:0.5em;
    right: 0.5em;
    color: #333;
    font-size: 0.8em;
    z-index: 10;
}
.imgRect .center{
   padding-top: 4.5em;
   font-size: 0.8em;
   color: #A2A2A2;
}
.imgRect .imgprivel{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.imgRect .uploadButton{
  width: 12em;
  height: 12em;
}
.phoneRect{

}
.phoneRect .title{
    margin: 1em 0 ;
    text-align: center;
    color: #fff;
    font-size: 1.1em;
    text-align: center;
}
.emptyRect{
  height: 5em;
}
.downButton{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 62px;
}
.downButton button{
  background-color: #0092FA;
  border: #0092FA;
  width: 100%;
  height: 62px;
}
.qrCode{
 width: 100%;
   box-sizing: border-box;
 padding: 2em;
}
</style>
